import React from 'react';
import styles from './logo.module.css';

const Logo = () => {
  return (
    <div className={styles.logo}>
      <span className={styles.firstName}>Isak</span>
      <span className={styles.lastName}>Rahmani</span>
    </div>
  );
};

export default Logo;
